export default __webpack_public_path__ + "locales/ru/Payments.json?hash=1a57de831f6faaeae86f21fa060f9ef9";